var map = {
	"./bg01.jpg": 5114,
	"./bg02.jpg": 9712,
	"./bg03.jpg": 8106,
	"./bg04.jpg": 5357,
	"./bg05.jpg": 4426,
	"./bg06.jpg": 5598,
	"./bg07.jpg": 7271,
	"./bg08.jpg": 1556,
	"./en.jpg": 8679,
	"./login_bg.jpg": 8210,
	"./login_bg1.jpg": 7762,
	"./register_bg.jpg": 6918,
	"./th.jpg": 7694,
	"./vi.jpg": 9769,
	"./zh.jpg": 4268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;